import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';

const PublisherLogoContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
`;
const PublisherLogoElement = styled.img`
    max-width: 111px;
    max-height: 24px;
`;
const PublisherLogo = props => (
    <PublisherLogoContainer>
        <PublisherLogoElement src={props.logoUrl} alt="" onClick={props.onClick} />
    </PublisherLogoContainer>
);

PublisherLogo.propTypes = {
    logoUrl: PropTypes.string,
    onClick: PropTypes.func
};

export default PublisherLogo;
